import axios from 'axios';
import auth from "../utils/auth";
import {AuthContext} from "../utils/AuthContext";
import React from "react";

const API_URL = process.env.REACT_APP_API_URL
const API_PATH = process.env.REACT_APP_API_PATH
console.log('API API_URL:', API_URL, ' API_PATH:', API_PATH);

const appClient = axios.create({
    baseURL: API_URL + API_PATH,
    headers: {
        'ngrok-skip-browser-warning': 'true',
    },
});

const getAccessToken = () => {
    let token = localStorage.getItem('accessToken');
    /*const authContext = React.useContext(AuthContext)
    if (!token) {
        token = accessToken;
    }*/
    return token;
}


// Добавляем заголовок Authorization для каждого запроса
appClient.interceptors.request.use((config) => {
    const accessToken= getAccessToken()
    console.log('Token to auth:', accessToken);
    if (accessToken) {
        config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
});


// Обработчик ошибок ответа
appClient.interceptors.response.use(
    (response) => response, // Успешный ответ
    async (error) => {
        const originalRequest = error.config;

        // Если ошибка 401 (нет доступа), пробуем обновить токен
        if (error.response?.status === 401) {
            try {
                const {res, token} = await auth(window.Telegram.WebApp.initData);

                if (!res) {
                    console.error('User not authenticated');
                    throw new Error('User not authenticated');
                }

                // Добавляем новый accessToken в заголовки запроса
                originalRequest.headers['Authorization'] = `Bearer ${token}`;
                // Повторяем оригинальный запрос
                return appClient(originalRequest);
            } catch (refreshError) {
                console.error('Error refreshing token:', refreshError);
                // Если ошибка при обновлении, удаляем токены и перенаправляем на логин
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                //TODO logic if non auth user
            }
        }

        return Promise.reject(error);
    }
);


export default appClient;